import { Link } from "react-router-dom";

export function Logo() {
  return (
    <Link to="/" className="logo">
      <span className="logo-dot" aria-hidden="true" />
      <span>Alt Tribe</span>
    </Link>
  );
}
